import React, {Component} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {Alert, AlertWarning} from '@homeaway/react-alerts';
import * as SvgDefinitons from '@homeaway/svg-defs';
import {SMALL, MEDIUM} from '../helpers/IconSize';
import IconTypes from '../helpers/IconTypes';
import {buildMessage, getIconProps} from '../helpers/helpers';


import './BaseUrgencyMessage.less';
const NEW_LINE_PLACEHOLDER = '{NEW_LINE_PLACEHOLDER}';

export const SvgLibDefinedIcons = {
    INFO: 'INFO__24',
    // WARN def is here for consistency reasons and to use map condition, icon is defined by @homeaway/react-alerts: AlertWarning component
    WARN: 'ALERT_WARNING__24',
    DELAY_REFUND: 'DELAY_REFUND_COLOR__24'
};

export default class BaseUrgencyMessage extends Component {
    static defaultProps = {
        className: '',
        size: MEDIUM,
        unitMessage: {},
        color: false,
        ariaHidden: false
    };
    static contextType = TrackingContext;

    BASE_CLASS = 'UrgencyUnitMessage';

    generateAlertComponent(componentGenerationParams) {
        const {icon} = componentGenerationParams;
        const urgencyComponent = this.generateUrgencyComponent(componentGenerationParams);

        if (icon === IconTypes.WARN) {
            return (
                <AlertWarning msg={urgencyComponent}/>
            );
        }
        const svgIconKey = SvgLibDefinedIcons[icon];
        let flairClassName;
        let svgClassName;
        if (icon === IconTypes.INFO) {
            flairClassName = 'bg--accent-orange-light';
            svgClassName = 'text--accent-orange-light';
        }

        return (
            <Alert
                msg={urgencyComponent}
                flairClassName={flairClassName}
                svgClassName={svgClassName}
                svgMarkup={SvgDefinitons[svgIconKey]}
                subtle
            />
        );
    }

    generateUrgencyComponent(componentGenerationParams) {
        const {baseClass, className, ariaHidden, src, size, icon, title, message, link, smallPrefix, isNewLine, style} = componentGenerationParams;
        return (
            <div className={`${baseClass} ${className}`} aria-hidden={ariaHidden}>
                {src &&
                    <div className={`${baseClass}__img--${size}`}>
                        <img style={style} src={src} alt={icon} />
                    </div>
                }
                <div className={`${baseClass}__message${smallPrefix}`}>
                    {
                        title &&
                        <span className={`${baseClass}__message${smallPrefix}__title`}><strong>{title}</strong></span>
                    }
                    {
                        isNewLine && <br/>
                    }
                    <span className={`${baseClass}__message${smallPrefix}__text`}>
                        {buildMessage(message, link, `${baseClass}__link`)}
                    </span>
                </div>
            </div>
        );
    }

    generateComponent = ({baseClass, className, size, color, ariaHidden}, urgencyMessageContent) => {
        const {icon, message, link} = urgencyMessageContent;
        if (!message) {
            return null;
        }
        let {title} = urgencyMessageContent;
        let isNewLine = false;
        const smallPrefix = size === SMALL ? '--s' : '';
        if (title && title.includes(NEW_LINE_PLACEHOLDER)) {
            title = title.replace(NEW_LINE_PLACEHOLDER, '');

            isNewLine = true;
        }
        let componentGenerationParams = {baseClass, className, size, ariaHidden, isNewLine, icon, message, link, title, smallPrefix};

        if (SvgLibDefinedIcons[icon]) {
            delete componentGenerationParams.className;
            return this.generateAlertComponent(componentGenerationParams);
        }

        const {style, src} = getIconProps(icon, size, color);
        componentGenerationParams = {style, src, ...componentGenerationParams};
        return this.generateUrgencyComponent(componentGenerationParams);
    };
}
